import Api from "api-client";

export async function isEvTaxation(company) {
  try {
    let companyDetails = await Api.getCompany(company.id);

    if (companyDetails.data.isEv && companyDetails.data.taxForms && companyDetails.data.taxForms.length > 0) {
      for (let taxForm of companyDetails.data.taxForms) {
        //   ha katas vagy teteles akkor return false
        if (taxForm.form === 'KATA' || taxForm.form === 'TETELES_ADOZO') {
          return false;
        }
        // ha atalanyadozo akkor true
        if (
            taxForm.form === 'ATALANYADOZO' &&
            taxForm.startDate && new Date(taxForm.startDate) <= new Date()
        ) {
          return true;
        }

      }
    }
    return false;

  } catch (error) {
    console.error('Error fetching company data:', error);
    return false;
  }
}

export function getLatestActiveTaxFrequency(company) {
  if (company.taxFrequencies && company.taxFrequencies.length > 0) {
    return company.taxFrequencies[0];
  }
  return null;
}

export function getLatestTaxForm(company) {
  if (company.taxForms && company.taxForms.length > 0) {
    return company.taxForms[0];
  }
  return null;
}

export function getLatestCompanyForm(company) {
  if (company.companyForm) {
    return company.companyForm
  }
  return null;
}

export function getErrorMessagesForField(errors, field) {
  let fieldErrors = errors.filter(error => error.field === field);
  let errorMessages = fieldErrors.flatMap(error => error.errors.map(e => e.errorMessage));
  let errorMessageString = errorMessages.join(', ');
  return errorMessageString;
}

export function resolveValue(array, searchValue) {
    const foundItem = array.find(item => item['id'] === searchValue);
    return foundItem ? foundItem.name : undefined;
}
